var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
// @ts-ignore
import Dropzone from 'react-dropzone';
import { Box, Button, Typography, palette } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import { PHOTO_REQUIREMENT_ERROR } from 'shared-assets/facesheet-ui/service/patient/types';
var StyledDropzone = styled(Dropzone)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 16vw;\n  background: ", ";\n  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.25);\n"], ["\n  display: flex;\n  width: 100%;\n  height: 16vw;\n  background: ", ";\n  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.25);\n"])), palette.background.default);
var BrowseButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    font-weight: 600;\n    padding: 0;\n  }\n"], ["\n  && {\n    font-weight: 600;\n    padding: 0;\n  }\n"])));
var BrowsePhoto = function (_a) {
    var onDrop = _a.onDrop;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var dropzoneRef;
    var handleFileDropError = function () {
        enqueueSnackbar(PHOTO_REQUIREMENT_ERROR, {
            variant: 'error',
        });
    };
    return (React.createElement(StyledDropzone, { accept: ".jpeg, .jpg, .png, .gif, .tif", multiple: false, onDrop: onDrop, maxSize: 5242880, ref: function (node) {
            dropzoneRef = node;
        }, onDropRejected: handleFileDropError },
        React.createElement(Grid, { container: true, direction: "column", justify: "center", alignItems: "center" },
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { variant: "h1", color: "textSecondary" },
                    "Drag a photo here or",
                    ' ',
                    React.createElement(BrowseButton, { variant: "text", color: "vitality" }, "browse"))),
            React.createElement(Grid, { item: true },
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "body1", component: "div" },
                        "Image requirements:",
                        React.createElement("ul", null,
                            React.createElement("li", null, "Format: jpeg, jpg, png, gif, or tif"),
                            React.createElement("li", null, "Size less than 5mb"))))))));
};
export default BrowsePhoto;
var templateObject_1, templateObject_2;
